import React from 'react';
import { CustomModal } from '../../../components/uikit/modal/CustomModal.tsx';
import { ButtonColor } from '../../../components/uikit/buttons/Button.tsx';
import styles from './designerSinglePage.module.scss';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';

type Props = {
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
};

export const RemindModalContent = (props: Props) => {
  const i18n = useScopedTranslation('Page.PageDesigner');

  const { onClose, onCancel, onSubmit } = props;

  return (
    <CustomModal
      isOpen={true}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onClose={onClose}
      cancelButtonText={i18n.t('remind_modal_negative_option')}
      submitButtonText={i18n.t('remind_modal_positive_option')}
      submitButtonType={ButtonColor.Primary}
      cancelButtonType={ButtonColor.Warning}
      titleText={i18n.t('remind_modal_title')}
      containerClassName={styles.modalBodyMinWidth480}
    >
      {i18n.t('remind_modal_body')}
    </CustomModal>
  );
};
